import React, { useEffect, useState } from "react";
import { getAllTransactions } from "../../../apis/ChargingHistoryApi";
import { Link, useParams } from "react-router-dom";
import { Table } from "antd";
import getTransactionColumns from "../../../const/Columns/getTransactionColumns";

const ChargingHistory = () => {
  const { id } = useParams();
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState(id || "");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    fetchUsers({ userId, startTime, endTime, status });
  }, [userId, startTime, endTime, status]);

  const fetchUsers = async (body) => {
    try {
      const res = await getAllTransactions(body);
      setTransactions(res.result);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const columns = getTransactionColumns();
  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="d-flex  justify-content-between  align-items-center">
              <div className="d-flex flex-column w-25">
                <label htmlFor="userIdInput" className="form-label">
                  User ID
                </label>
                <input
                  type="text"
                  placeholder="Search by UserId"
                  className="form-control w-20"
                  value={userId}
                  onChange={(e) => setUserId(e.target.value)}
                />
              </div>
              <div className="d-flex flex-column w-25">
                <label htmlFor="startDateInput" className="form-label">
                  Start Date
                </label>
                <input
                  type="date"
                  placeholder="Search with start date"
                  className="form-control w-20"
                  value={startTime}
                  onChange={(e) => setStartTime(e.target.value)}
                />
              </div>
              <div className="d-flex flex-column w-25">
                <label htmlFor="endDateInput" className="form-label">
                  End Date
                </label>
                <input
                  type="date"
                  placeholder="Search with end date"
                  className="form-control w-20"
                  value={endTime}
                  onChange={(e) => setEndTime(e.target.value)}
                />
              </div>
              <div className="d-flex flex-column w-25">
                <label htmlFor="statusInput" className="form-label">
                  Status
                </label>
                <input
                  type="text"
                  placeholder="Search with status"
                  className="form-control w-20"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                />
              </div>
            </div>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div className="table-respoinsive" style={{ overflowX: "auto" }}>
                <Table
                  columns={columns}
                  dataSource={transactions?.length > 0 ? transactions : []}
                  className="table-striped "
                  rowKey={(record) => record.id}
                  // scroll={{ y: 400 }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ChargingHistory;
